import { createContext } from 'react';
const ActionButtonContext = createContext({});
export default ActionButtonContext;